var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnGeneralLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5175 17.0615H13.0001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 17.0615L26.5105 17.0615",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1231 17.1452C21.1231 16.6124 21.281 16.0916 21.577 15.6486C21.873 15.2056 22.2937 14.8604 22.7859 14.6565C23.2782 14.4526 23.8198 14.3993 24.3423 14.5032C24.8648 14.6071 25.3448 14.8637 25.7215 15.2404C26.0982 15.6171 26.3548 16.0971 26.4587 16.6196C26.5627 17.1422 26.5093 17.6838 26.3054 18.176C26.1016 18.6682 25.7563 19.0889 25.3133 19.3849C24.8703 19.6809 24.3495 19.8389 23.8168 19.8389C23.1024 19.8389 22.4172 19.5551 21.912 19.0499C21.4069 18.5447 21.1231 17.8596 21.1231 17.1452V17.1452Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4293 27.1631L31 27.1631",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0419 26.8541C13.0419 27.3869 13.1999 27.9077 13.4959 28.3507C13.7918 28.7937 14.2125 29.1389 14.7048 29.3428C15.197 29.5467 15.7386 29.6 16.2611 29.4961C16.7837 29.3922 17.2636 29.1356 17.6403 28.7589C18.0171 28.3822 18.2736 27.9022 18.3776 27.3797C18.4815 26.8571 18.4282 26.3155 18.2243 25.8233C18.0204 25.3311 17.6751 24.9104 17.2322 24.6144C16.7892 24.3184 16.2684 24.1604 15.7356 24.1604C15.0212 24.1604 14.336 24.4442 13.8309 24.9494C13.3257 25.4546 13.0419 26.1397 13.0419 26.8541Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGeneralLight);
export default __webpack_public_path__ + "static/media/btn_general_light.bfecbe5c818660f4270bca674edd7c25.svg";
export { ForwardRef as ReactComponent };